import React, { Component } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { firebase } from '../../../firebase';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import backendUrl from '../../../constants/urls';
import { addSingleCourse, resetCart } from '../../../store/actions/cartActions';
import { css } from 'glamor';
import { encodeUser } from '../../../methods/api-calls';
import { convertToSlug } from '../../../utils/id';

const containerStyle = css({
  position: 'relative',
});

class AddCourseModal extends Component {
  state = {
    modal: false,
    imageUrls: [],
    imageCount: 0,
    imageHoverUrl: '',
    certificateContent: '',
    notAvailable: '',
    progress: 0,
    header: '',
    title: '',
    discountReason: '',
    description: '',
    shortDescription: '',
    targetPublic: '',
    objectives: '',
    methodology: '',
    zoomLink: '',
    content: '',
    offer: false,
    totalDuration: 0,
    oldPrice: 0,
    oldPriceForThree: 0,
    oldPriceForTwo: 0,
    category: null,
    professor: null,
    newPrice: 0,
    newPriceForThree: 0,
    newPriceForTwo: 0,
    maxParticipants: 0,
    hasMaxParticipants: false,
    quantity: 0,
    discount: false,
    isFree: false,
    currency: '',
    discountOff: 0,
    priority: 0,
    onSale: false,
    previewImages: [],
    allCategories: [],
    previewImageHover: null,
    slug: '',
  };

  baseState = this.state;

  componentDidMount() {
    const db = firebase.firestore();
    let dbOrderRef = db.collection('categories');
    let categoriesArray = [];
    dbOrderRef
      .get()
      .then(res => {
        res.forEach(doc => {
          let categoriesObj = doc.data();
          categoriesObj.id = doc.id;
          categoriesArray.push(categoriesObj);
        });
        this.setState({
          allCategories: categoriesArray,
        });
      })
      .catch(err => {
        console.log('error', err);
      });

    dbOrderRef = db.collection('professors');
    let professorsArray = [];
    dbOrderRef
      .get()
      .then(res => {
        // console.log(res)
        res.forEach(doc => {
          let professorsObj = doc.data();
          professorsObj.id = doc.id;
          professorsArray.push(professorsObj);
        });
        this.setState({
          allProfessors: professorsArray,
          professor: professorsArray && professorsArray.length > 0 ? professorsArray[0] : null,
        });
      })
      .catch(err => {
        console.log('error', err);
      });
  }

  handleSelect = (id, array, key) =>
    this.setState({
      [key]: array.find(e => e.id == id) ? array.find(e => e.id == id) : null,
    });

  resetForm = () => {
    this.setState(this.baseState);
  };

  closeModal = () => {
    this.props.onClick(this.state.modal);
  };

  handleChange = e => {
    if (this.state.imageCount < 4) {
      if (e.target.files[0]) {
        let image = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(image);
        reader.onload = () => {
          this.setState({
            previewImages: [...this.state.previewImages, reader.result],
          });
        };
        this.handleUpload(image);
      }
    }
  };

  handleUpload = image => {
    const data = new FormData();
    if (image) {
      const authHeader = encodeUser();
      data.append('productImage', image, image.name);
      axios
        .post(`${backendUrl}api/upload`, data, {
          headers: {
            accept: 'application/json',
            'Accept-Language': 'en-US,en;q=0.8',
            'Content-Type': `multipart/form-data; boundary=${data._boundary}`,
            ...authHeader,
          },
        })
        .then(response => {
          if (200 === response.status) {
            // If file size is larger than expected.
            if (response.data.error) {
              if ('LIMIT_FILE_SIZE' === response.data.error.code) {
                alert('Tamaño máximo: 20MB');
              } else {
                // If not the given file type
                alert(response.data.error);
              }
            } else {
              // Success
              let fileName = response.data;
              this.setState({
                imageUrls: [...this.state.imageUrls, fileName.location],
                imageCount: this.state.imageCount + 1,
              });
              console.log('fileName', fileName.location);
              // alert( 'File Uploaded', '#3089cf' );
            }
          }
        })
        .catch(error => {
          // If another error
          alert(error, 'red');
        });
    } else {
      // if file not selected throw error
      alert('Porfavor seleccione una foto');
    }
  };

  handleChangeHover = e => {
    if (e.target.files[0]) {
      let imageHover = e.target.files[0];
      let reader = new FileReader();
      reader.readAsDataURL(imageHover);
      reader.onload = () => {
        this.setState({ previewImageHover: reader.result });
      };
      this.handleUploadHover(imageHover);
    }
  };

  handleUploadHover = imageHover => {
    const data = new FormData();
    if (imageHover) {
      const authHeader = encodeUser();
      data.append('productImageHover', imageHover, imageHover.name);
      axios
        .post(`${backendUrl}api/upload-hover`, data, {
          headers: {
            accept: 'application/json',
            'Accept-Language': 'en-US,en;q=0.8',
            'Content-Type': `multipart/form-data; boundary=${data._boundary}`,
            ...authHeader,
          },
        })
        .then(response => {
          if (200 === response.status) {
            // If file size is larger than expected.
            if (response.data.error) {
              if ('LIMIT_FILE_SIZE' === response.data.error.code) {
                alert('Tamaño máximo: 20MB');
              } else {
                console.log(response.data);
                // If not the given file type
                // alert( response.data.error, 'red' );
              }
            } else {
              // Success
              let fileName = response.data;
              this.setState({
                imageHoverUrl: fileName.location,
              });
              // console.log( 'fileName', fileName.location );
              // alert( 'File Uploaded', '#3089cf' );
            }
          }
        })
        .catch(error => {
          // If another error
          alert(error);
        });
    } else {
      // if file not selected throw error
      alert('Please upload file');
    }
  };

  parseToBoolean = val => {
    if (typeof val === 'boolean') {
      return Boolean(val);
    } else if (val == 'true') {
      return Boolean(true);
    } else {
      return Boolean(false);
    }
  };

  addCourse = e => {
    e.preventDefault();
    let {
      imageHoverUrl,
      header,
      description,
      content,
      shortDescription,
      objectives,
      methodology,
      oldPrice,
      oldPriceForTwo,
      oldPriceForThree,
      imageUrls,
      newPrice,
      currency,
      newPriceForTwo,
      newPriceForThree,
      discount,
      discountOff,
      targetPublic,
      totalDuration,
      isFree,
      category,
      zoomLink,
      professor,
      title,
      onSale,
      notAvailable,
      discountReason,
      hasMaxParticipants,
      maxParticipants,
      priority,
      certificateContent,
      slug,
    } = this.state;
    const thereAreImages = imageUrls && imageUrls.length > 0;

    const course = {
      notAvailable: notAvailable,
      imageUrl: thereAreImages ? imageUrls[0] : '',
      imageUrlSecond: thereAreImages && imageUrls.length > 1 ? imageUrls[1] : '',
      imageUrlThird: thereAreImages && imageUrls.length > 2 ? imageUrls[2] : '',
      imageUrlFourth: thereAreImages && imageUrls.length > 3 ? imageUrls[3] : '',
      imageHoverUrl: imageHoverUrl,
      header: header,
      title: title,
      description: description,
      content: content,
      objectives: objectives,
      category: category ? category : null,
      shortDescription: shortDescription,
      methodology: methodology,
      professor: professor ? professor : null,
      totalDuration: totalDuration,
      targetPublic: targetPublic,
      zoomLink: zoomLink,
      currency: currency,
      isFree: this.parseToBoolean(isFree),
      oldPrice: isFree ? 0 : Number(oldPrice),
      oldPriceForTwo: isFree ? 0 : Number(oldPriceForTwo),
      oldPriceForThree: isFree ? 0 : Number(oldPriceForThree),
      newPrice: isFree ? 0 : Number(newPrice),
      newPriceForTwo: isFree ? 0 : Number(newPriceForTwo),
      newPriceForThree: isFree ? 0 : Number(newPriceForThree),
      discount: this.parseToBoolean(discount),
      discountOff: Number(discountOff),
      maxParticipants: Number(maxParticipants),
      quantity: Number(maxParticipants), //Then it has to decrement
      hasMaxParticipants: this.parseToBoolean(hasMaxParticipants),
      onSale: this.parseToBoolean(onSale),
      offer: this.parseToBoolean(onSale),
      discountReason: discountReason,
      priority: Number(priority),
      certificateContent: certificateContent,
      slug: convertToSlug(slug) || convertToSlug(title),
    };

    if (title != '' && professor && description && ((!isFree && newPrice && currency) || isFree)) {
      const db = firebase.firestore();
      const dbOrderRef = db.collection('courses');
      dbOrderRef.add(course).then(res => {
        const { id } = res;
        course.id = id;
        this.props.addSingleCourse(course);
        toast.success('Curso fue creado exitosamente.', {
          position: 'bottom-left',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setTimeout(() => {
          window.location.reload();
        }, 3000);
        this.closeModal();
        this.resetForm();
        this.props.resetCart();
      });
    } else {
      toast.error('Rellene los campos', {
        position: 'bottom-left',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  render() {
    let { previewImageHover, previewImages, allCategories, allProfessors } = this.state;
    return (
      <React.Fragment>
        <div className={`admin-product-modal ${this.props.active}`}>
          <ToastContainer className={containerStyle} />

          <div className="modal-innter-content">
            <button type="button" className="close" onClick={this.closeModal}>
              <span aria-hidden="true">
                <i className="bx bx-x"></i>
              </span>
            </button>

            <div className="modal-body">
              <h3>Agregar Curso</h3>
              <p>Todos los campos marcados (*) son requeridos</p>

              <form onSubmit={this.addCourse}>
                <h4 className="title title-underline">Agregar imágenes aquí (opcional)</h4>

                <div className="form-group">
                  <label>Subir las imagenes aquí (Hasta 4 fotos)</label>

                  <div className="upload-img">
                    <span>
                      <i className="bx bxs-image-add"></i>
                      Seleccionar
                    </span>

                    <input
                      type="file"
                      disabled={this.state.imageCount > 3}
                      className="form-control-file"
                      name="productImage"
                      accept="image/*"
                      onChange={this.handleChange}
                    />
                  </div>

                  {previewImages && previewImages.length > 0 ? (
                    <div className="uploaded-img">
                      {previewImages.map(e => (
                        <img src={e} alt="Image" className="img-thumbnail" />
                      ))}
                    </div>
                  ) : null}
                </div>

                <h4 className="title title-underline">Agrega información del curso aquí</h4>

                <div className="form-group">
                  <label>Encabezado</label>
                  <p>Ej: "Taller"</p>
                  <input
                    type="text"
                    className="form-control"
                    value={this.state.header}
                    onChange={e => this.setState({ header: e.target.value })}
                  />
                </div>

                <div className="form-group">
                  <label>Título *</label>
                  <p>Ej: Negociación Avanzada</p>
                  <input
                    type="text"
                    className="form-control"
                    value={this.state.title}
                    onChange={e => this.setState({ title: e.target.value })}
                  />
                </div>

                <div className="form-group">
                  <label>Url del curso</label>
                  <input
                    type="text"
                    className="form-control"
                    value={this.state.slug}
                    onChange={e => this.setState({ slug: e.target.value })}
                  />
                  <p>Previsualización: {convertToSlug(this.state.slug)}</p>
                </div>

                <div className="form-group">
                  <label>Breve descripción (resumen para mostrar en Home)</label>
                  <p>Máx 210 caracteres.</p>
                  <textarea
                    className="form-control"
                    value={this.state.shortDescription}
                    maxLength={210}
                    onChange={e => this.setState({ shortDescription: e.target.value })}
                    rows="3"
                  />
                </div>

                <div className="form-group">
                  <label>Descripción *</label>
                  <textarea
                    className="form-control"
                    value={this.state.description}
                    onChange={e => this.setState({ description: e.target.value })}
                    rows="3"
                  />
                </div>

                <div className="form-group">
                  <label>Categoría</label>
                  <p>Recuerda agregar categorías en el panel.</p>
                  <select
                    className="form-control"
                    onChange={e =>
                      this.handleSelect(e.target.value, this.state.allCategories, 'category')
                    }
                  >
                    {allCategories && allCategories.length > 0 && (
                      <option value={null}>Sin categoría</option>
                    )}
                    {allCategories && allCategories.length > 0 ? (
                      allCategories.map(cat => <option value={cat.id}>{cat.title}</option>)
                    ) : (
                      <option disabled selected>
                        No hay categorías ingresadas
                      </option>
                    )}
                  </select>
                </div>

                <div className="form-group">
                  <label>Profesor a cargo *</label>
                  <p>Recuerda agregar profesores en el panel.</p>
                  <select
                    className="form-control"
                    onChange={e =>
                      this.handleSelect(e.target.value, this.state.allProfessors, 'professor')
                    }
                  >
                    {allProfessors && allProfessors.length > 0 ? (
                      allProfessors.map(p => <option value={p.id}>{p.fullName}</option>)
                    ) : (
                      <option disabled selected>
                        No hay profesores ingresados
                      </option>
                    )}
                  </select>
                </div>

                <div className="form-group">
                  <label>Objetivos</label>
                  <textarea
                    className="form-control"
                    value={this.state.objectives}
                    onChange={e => this.setState({ objectives: e.target.value })}
                    rows="3"
                  />
                </div>

                <div className="form-group">
                  <label>Contenido</label>
                  <textarea
                    className="form-control"
                    value={this.state.content}
                    onChange={e => this.setState({ content: e.target.value })}
                    rows="3"
                  />
                </div>

                <div className="form-group">
                  <label>Metodología</label>
                  <textarea
                    className="form-control"
                    value={this.state.methodology}
                    onChange={e => this.setState({ methodology: e.target.value })}
                    rows="3"
                  />
                </div>

                <div className="form-group">
                  <label>Dirigido a</label>
                  <textarea
                    className="form-control"
                    value={this.state.targetPublic}
                    onChange={e => this.setState({ targetPublic: e.target.value })}
                    rows="3"
                  />
                </div>

                <div className="form-group">
                  <label>Mensaje customizado en caso de agotado</label>
                  <p>*El mensaje por defecto es "NO HAY MÁS CUPOS". (Máx 30 caracteres)</p>
                  <input
                    type="text"
                    className="form-control"
                    value={this.state.notAvailable}
                    onChange={e => this.setState({ notAvailable: e.target.value })}
                    maxLength={30}
                  />
                </div>

                <div className="form-group">
                  <label>Mensaje customizado para el cuerpo del certificado</label>
                  <p style={{ fontSize: '12px' }}>
                    Nota: Máx 250 caracteres. Por defecto, el cuerpo contendrá el texto que se
                    muestra debajo con los datos correspondientes.
                  </p>
                  <textarea
                    className="form-control"
                    placeholder="Ej: Ha asistido y cumplido con los requisitos del curso Negociación Estratégica dictado los días 17, 18,
										19 de Noviembre de 2020, extiendo el presente certificado en Montevideo el 30 de Noviembre de
										2020."
                    value={this.state.certificateContent}
                    maxLength={250}
                    onChange={e => this.setState({ certificateContent: e.target.value })}
                    rows="3"
                  />
                </div>

                <div className="form-group">
                  <label>Total duración en horas</label>
                  <input
                    className="form-control"
                    value={this.state.totalDuration}
                    onChange={e => this.setState({ totalDuration: e.target.value })}
                    rows="3"
                  />
                </div>

                <div className="form-group">
                  <label>¿Tiene capacidad de personas?</label>
                  <select
                    className="form-control"
                    onChange={e => this.setState({ hasMaxParticipants: e.target.value })}
                  >
                    <option value="false">No</option>
                    <option value="true">Si</option>
                  </select>
                </div>

                {this.state.hasMaxParticipants == 'true' && (
                  <div className="form-group">
                    <label>Máx. cantidad de personas</label>
                    <input
                      type="number"
                      min={0}
                      className="form-control"
                      value={this.state.maxParticipants}
                      onChange={e => this.setState({ maxParticipants: e.target.value })}
                    />
                  </div>
                )}

                <div className="form-group">
                  <label>Prioridad</label>
                  <p>
                    *Por defecto, todos cuentan con prioridad 0. La mayor prioridad aparecerá
                    primero.
                  </p>
                  <input
                    type="number"
                    min={0}
                    className="form-control"
                    value={this.state.priority}
                    onChange={e => this.setState({ priority: e.target.value })}
                  />
                </div>

                <div className="form-group">
                  <label>Link de la reunión por zoom</label>
                  <input
                    className="form-control"
                    value={this.state.zoomLink}
                    onChange={e => this.setState({ zoomLink: e.target.value })}
                    rows="3"
                  />
                </div>

                <h4 className="title title-underline">Agrega información de los precios aquí</h4>

                <div className="form-group">
                  <label>¿Está en sale? (Aparecerá cartel "SALE")</label>
                  <select
                    className="form-control"
                    onChange={e => this.setState({ onSale: e.target.value })}
                  >
                    <option value="false">No</option>
                    <option value="true">Si</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>¿Descuento? (Aparecerá cartel "XX % DESCUENTO")</label>
                  <select
                    className="form-control"
                    onChange={e => this.setState({ discount: e.target.value })}
                  >
                    <option value="false">No</option>
                    <option value="true">Si</option>
                  </select>
                </div>

                {this.state.discount && this.state.discount == 'true' && (
                  <>
                    <div className="form-group">
                      <label>Motivo descuento (Ej: Aparecerá cartel "PRECIO LANZAMIENTO")</label>
                      <input
                        type="text"
                        className="form-control"
                        value={this.state.discountReason}
                        onChange={e => this.setState({ discountReason: e.target.value })}
                      />
                    </div>
                    <div className="form-group">
                      <label>Descuento en porcentaje (1 o 10 ...)</label>
                      <input
                        type="number"
                        min={1}
                        className="form-control"
                        value={this.state.discountOff}
                        onChange={e => this.setState({ discountOff: e.target.value })}
                      />
                    </div>
                  </>
                )}

                <div className="form-group">
                  <label>¿Es GRATUITO? </label>
                  <select
                    className="form-control"
                    onChange={e => this.setState({ isFree: e.target.value })}
                  >
                    <option value="false">No</option>
                    <option value="true">Si</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>Moneda </label>
                  <select
                    className="form-control"
                    onChange={e => this.setState({ currency: e.target.value })}
                    value={this.state.currency}
                  >
                    <option disabled value="">
                      Seleccione...
                    </option>

                    <option value="USD">USD</option>
                    <option value="UYU">UYU</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>
                    PRECIOS<strong> VIEJOS</strong>(Si no es gratuito, ni está en sale ni tiene % de
                    descuento no completar)
                  </label>
                  <p>
                    Para <strong>1</strong> persona
                  </p>
                  <input
                    type="number"
                    min={0}
                    className="form-control"
                    value={this.state.oldPrice}
                    onChange={e => this.setState({ oldPrice: e.target.value })}
                  />
                  <p>
                    Para <strong>2</strong> personas
                  </p>
                  <input
                    min={0}
                    type="number"
                    className="form-control"
                    value={this.state.oldPriceForTwo}
                    onChange={e => this.setState({ oldPriceForTwo: e.target.value })}
                  />
                  <p>
                    Para <strong>3</strong> personas
                  </p>
                  <input
                    min={0}
                    type="number"
                    className="form-control"
                    value={this.state.oldPriceForThree}
                    onChange={e => this.setState({ oldPriceForThree: e.target.value })}
                  />
                </div>

                <div className="form-group">
                  <label>
                    PRECIOS<strong> ACTUALES</strong>
                  </label>
                  <p>
                    Para <strong>1</strong> persona (* obligatorio)
                  </p>
                  <input
                    min={0}
                    type="number"
                    className="form-control"
                    value={this.state.newPrice}
                    onChange={e => this.setState({ newPrice: e.target.value })}
                  />
                  <p>
                    Para <strong>2</strong> personas
                  </p>
                  <input
                    min={0}
                    type="number"
                    className="form-control"
                    value={this.state.newPriceForTwo}
                    onChange={e => this.setState({ newPriceForTwo: e.target.value })}
                  />
                  <p>
                    Para <strong>3</strong> personas
                  </p>
                  <input
                    min={0}
                    type="number"
                    className="form-control"
                    value={this.state.newPriceForThree}
                    onChange={e => this.setState({ newPriceForThree: e.target.value })}
                  />
                </div>
                <div className="modal-btn">
                  <div className="btn optional-btn float-left" onClick={this.closeModal}>
                    Cancelar
                  </div>
                  <button className="btn default-btn float-right">Crear Curso</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    addSingleCourse: course => {
      dispatch(addSingleCourse(course));
    },
    resetCart: () => {
      dispatch(resetCart());
    },
  };
};

export default connect(null, mapDispatchToProps)(withRouter(AddCourseModal));
